import { GET, omsBaseUrlApi, PUT } from '@constants/generic-constants';
import NetworkManager from '../../services/network-service';

export const getNotificationsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/notifications${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const markReadApi = (body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/notifications/mark_read`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
